import { groupByID, groupCreate, groupDestroy, groupList, groupUpdate } from '@/services/agency/kpi-groups.service'

export default {
	namespaced: true,
	state: {
		// SERVICE GROUP
		groupList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		group: {},

		// STATUS SERVICE GROUP
		groupStatus: 'pending',
		groupSaveStatus: 'init',
		groupDeleteStatus: 'init',
	},
	getters: {
		// SERVICE GROUP
		getGroupList(state) {
			return state.groupList
		},
		getGroup(state) {
			return state.group
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE GROUP
		getGroupDeleteStatus(state) {
			return state.groupDeleteStatus
		},
		getGroupSaveStatus(state) {
			return state.groupSaveStatus
		},
		getGroupStatus(state) {
			return state.groupStatus
		},
	},
	mutations: {
		// SERVICE GROUP
		GROUP_LIST(state, value) {
			state.groupList = value
		},
		SET_GROUP(state, value) {
			state.group = value
		},

		// STATUS SERVICE GROUP
		GROUP_STATUS(state, value) {
			state.groupStatus = value
		},
		GROUP_SAVE_STATUS(state, value) {
			state.groupSaveStatus = value
		},
		GROUP_DELETE_STATUS(state, value) {
			state.groupDeleteStatus = value
		},
	},
	actions: {
		// Service Group
		async fetchGroupList({ commit }, params) {
			commit('GROUP_STATUS', 'pending')
			commit('GROUP_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await groupList(params)
				commit('GROUP_STATUS', 'init')
				commit('GROUP_LIST', data)
				return data
			} catch (error) {
				commit('GROUP_STATUS', 'init')
				throw error
			}
		},
		async fetchGroupByID({ commit }, params) {
			commit('GROUP_STATUS', 'pending')
			try {
				const { data } = await groupByID(params)
				commit('GROUP_STATUS', 'init')
				commit('SET_GROUP', data.data)
				return data
			} catch (error) {
				commit('GROUP_STATUS', 'init')

				return error
			}
		},
		async saveNewGroup({ commit }, params) {
			commit('GROUP_SAVE_STATUS', 'pending')
			try {
				const { data } = await groupCreate(params)
				commit('GROUP_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('GROUP_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateGroup({ commit }, params) {
			commit('GROUP_SAVE_STATUS', 'pending')
			try {
				const { data } = await groupUpdate(params)
				commit('GROUP_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('GROUP_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteGroupByID({ commit }, params) {
			commit('GROUP_DELETE_STATUS', 'pending')
			try {
				const { data } = await groupDestroy(params)
				commit('GROUP_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('GROUP_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
